module.exports = __webpack_public_path__ + "static/media/b0.10b03678.png";